export const competitionExperimentGroups = {
  default: 'A',
  hideCompetitors: 'A',
  showCompetitors: 'B',
} as const;

export const competitionExperimentName = 'mnz_fvu_competition';

type Val<T extends Object> = T[keyof T];

export type TCompetitionExperimentGroupsNames = Val<typeof competitionExperimentGroups>;
